var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailOpenedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6429 9.58792V16.5981C19.6429 17.2753 19.3738 17.9248 18.8949 18.4037C18.416 18.8826 17.7665 19.1516 17.0893 19.1516H4.91071C4.23347 19.1516 3.58395 18.8826 3.10507 18.4037C2.62618 17.9248 2.35714 17.2753 2.35714 16.5981V9.58792C2.35714 9.50699 2.36186 9.42606 2.3705 9.34671L10.6873 14.5442C10.7689 14.5952 10.8618 14.6255 10.9578 14.6324C11.0538 14.6392 11.15 14.6224 11.2381 14.5835L11.3127 14.5442L19.6295 9.34671C19.6381 9.42606 19.6429 9.50699 19.6429 9.58792ZM11.3237 2.94549L18.6701 7.78314C18.8642 7.91042 19.0324 8.06599 19.173 8.24199L11 13.3491L2.827 8.24199C2.96764 8.06599 3.13657 7.91042 3.32986 7.78314L10.6763 2.94549C10.7725 2.88213 10.8852 2.84836 11.0004 2.84836C11.1156 2.84836 11.2283 2.88213 11.3245 2.94549H11.3237Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenedIcon);
export default __webpack_public_path__ + "static/media/MailOpenedIcon.e26c3882c22273bda9d471c618b4bc98.svg";
export { ForwardRef as ReactComponent };